import { render, staticRenderFns } from "./ScorekeeperTopbar.vue?vue&type=template&id=52540c26"
import script from "./ScorekeeperTopbar.vue?vue&type=script&lang=js"
export * from "./ScorekeeperTopbar.vue?vue&type=script&lang=js"
import style0 from "./ScorekeeperTopbar.vue?vue&type=style&index=0&id=52540c26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports